import script from "./TranslatorOpenJobs.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslatorOpenJobs.vue?vue&type=script&setup=true&lang=js"

import "./TranslatorOpenJobs.vue?vue&type=style&index=0&id=7cc5b09c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc5b09c"]])

export default __exports__